import {Component, Input, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ResizeEvent} from "angular-resizable-element";
import {ToastrService} from "ngx-toastr";
import {Requirement} from "../../../models/requirement";
import {RequirementControllerService} from "../../../services/requirement-controller/requirement-controller.service";
import {NewDeterminantHelperService} from "../../../services/result-controller/new-determinant-helper.service";
import {ModalService} from "../../utils/base_modal.component";
import {TranslatedBaseError} from "../TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";
import {DeterminantControllerService} from "../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "documents-table",
  templateUrl: "./documents-table.component.html",
  providers: [RequirementControllerService, ModalService, NewDeterminantHelperService, ToastrService],
  styles: [".cursor-hand {cursor: pointer;}"],
})
export class DocumentsTableComponent extends TranslatedBaseError implements OnInit {
  @Input() public hideList: boolean = false;
  public serviceId: string;
  public determinantMapById: { [key: string]: string };
  public documents: any[] = [];

  public style: object = {};
  public document: any;
  public showEdit: boolean = false;
  public showAdd: boolean = false;
  public newCustomFilterBy: string;
  public elementsNumber: string;

  constructor(private route: ActivatedRoute,
              private requirementControllerService: RequirementControllerService,
              private determinantService: DeterminantControllerService,
              private router: Router,
              public translateService: TranslateService,
              toastr: ToastrService) {
    super(toastr, translateService);

    }

    public sortNotification(event) {
        this.specifySortNumbers(this.documents);
        this.saveRequirements(this.documents);
    }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.getServiceDeterminantKeyName();
    });
    this.getSystemDocuments();
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public deleteRequirement(requirement) {
    this.requirementControllerService.deleteRequirement(requirement.id).subscribe(
      (data) => {
        this.responseSuccessful("Requirement is deleted!");
        this.ngOnInit();
        this.router.navigate(["/services/" + this.serviceId + "/documentstable"]);
      },
      (error) => this.showErrorMessageWithTitle("Requirement delete error! ", error),
    );
  }

  public specifySortNumbers(reqs: Requirement[]) {
    let sortNumber = 0;
    reqs.forEach((req) => {
      sortNumber = sortNumber + 1;
      req.sortOrder = sortNumber;
    });
  }

  public sortRequirements(requirements: Requirement[]) {
    return requirements.sort((a, b) => {
      const num1 = a.sortOrder;
      const num2 = b.sortOrder;
      return (num1 < num2) ? -1 : (num1 > num2) ? 1 : 0;
    });
  }

  public saveRequirements(list: Requirement[]) {
    list.forEach((req) => {
      this.saveRequirement(req);
    });
  }

  public saveRequirement(req: Requirement) {
    this.requirementControllerService.saveRequirement(req).subscribe(
      (data) =>
        (error) => this.showErrorMessage(error),
    );
  }

  public getSystemDocuments() {
    this.requirementControllerService.getServiceRequirements().subscribe(
      (data) => {
        this.documents = this.sortRequirements(data);
        this.elementsNumber = " (" + this.documents.length + ")";
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public update(item) {
    return this.requirementControllerService.saveRequirement(item).subscribe(
      (data) => {
        item.isInRenameMode = false;
        item.isLoading = false;
        this.responseSuccessful("Requirement is saved!");
      },
      (error) => {
        this.ngOnInit();
        return this.showErrorMessage(error);
      },
    );
  }

  public onNewFilterBy(value) {
    this.newCustomFilterBy = value;
  }

  public loadRequirement(document) {
    if (document) {
      this.document = this.documents.find((it) => {
        return it.id === document.id;
      });
      this.showEdit = true;
    } else {
      this.document = new Requirement();
      this.document.name = this.newCustomFilterBy;
      this.showAdd = true;
    }
  }

  public onResizeEnd(event: ResizeEvent) {
    this.style = {
      width: `${event.rectangle.width}px`,
    };
  }

  public closeSlider() {
    this.getSystemDocuments();
    this.closeLayers();
  }

  public closeLayers() {
    this.showAdd = false;
    this.showEdit = false;
    this.style = {};
  }

}
